import { useFacilityStore } from '@/features/_stores'
import type {
  TCreatePersonResponseBodyDTO,
  TFindPersonByIdResponseBodyDTO,
  TFindPersonsByCompanyIdResponseBodyDTO,
  TUpdatePersonResponseBodyDTO,
} from '@doutorsim/shared/exposed/persons'
import type { TCreatePersonInputDTO, TUpdatePersonActionInputDTO } from '@doutorsim/shared/persons'
import { apiClient } from '../api'

class PersonsApi {
  private getBaseUrl() {
    const facility = useFacilityStore.getState().currentFacility
    if (!facility?.companyId) {
      throw new Error('Company not selected')
    }

    return `/api/v1/companies/${facility?.companyId}/persons`
  }

  async getPersons() {
    const baseUrl = this.getBaseUrl()
    return apiClient.get<TFindPersonsByCompanyIdResponseBodyDTO>(baseUrl)
  }

  async getPersonById(id: string, companyId?: string) {
    const baseUrl = companyId ? `/api/v1/companies/${companyId}/persons` : this.getBaseUrl()
    return apiClient.get<TFindPersonByIdResponseBodyDTO>(`${baseUrl}/${id}`)
  }

  async createPerson(data: TCreatePersonInputDTO) {
    const baseUrl = this.getBaseUrl()
    return apiClient.post<TCreatePersonResponseBodyDTO>(baseUrl, data)
  }

  async updatePerson(data: TUpdatePersonActionInputDTO) {
    const baseUrl = this.getBaseUrl()
    return apiClient.put<TUpdatePersonResponseBodyDTO>(`${baseUrl}/${data.id}`, data)
  }

  //TODO DEV-42
  // async deletePerson(id: string) {
  //   const baseUrl = await this.getBaseUrl()
  //   return apiClient.delete(`${baseUrl}/${id}`)
  // }
}

export const personsApi = new PersonsApi()
